import script from "./BaseTreeview.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseTreeview.vue?vue&type=script&lang=ts&setup=true"

import "./BaseTreeview.vue?vue&type=style&index=0&id=5b08ddf1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b08ddf1"]])

export default __exports__